import { createProductLink as createProductLinkApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  CreateProductLinkServiceRequest,
  CreateProductLinkServiceResponse,
} from './create-product-link.dto';
import {
  CreateProductLinkServiceRequestDtoSchema,
  CreateProductLinkServiceResponseDtoSchema,
} from './create-product-link.dto';

export const createProductLinkService = withServiceErrorCapture(
  lazyPipe(
    // 1. Validate the incoming request object against a Zod schema.
    validateServiceRequest(CreateProductLinkServiceRequestDtoSchema),

    // 2. Execute the core business logic.
    async (request: CreateProductLinkServiceRequest): Promise<CreateProductLinkServiceResponse> => {
      // API Layer 호출
      const { data } = await createProductLinkApi({
        productId: request.productId,
      });

      // API 응답을 Service DTO로 변환
      const response: CreateProductLinkServiceResponse = {
        link: data.link,
        isCurator: data.isCurator,
      };

      return response;
    },

    // 3. Validate the final response object before it is returned.
    validateServiceResponse(CreateProductLinkServiceResponseDtoSchema),
  ),
);
